
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/faves",
      function () {
        return require("private-next-pages/profile/faves.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/faves"])
      });
    }
  